var map = {
	"./afterglow.jpg": 1301,
	"./cali.jpg": 1302,
	"./dalliance.jpg": 1303,
	"./dare.jpg": 1304,
	"./drama.jpg": 1305,
	"./edge.jpg": 1306,
	"./epic.jpg": 1307,
	"./festival.jpg": 1308,
	"./greyscale.jpg": 1309,
	"./none.jpg": 1310,
	"./nordic.jpg": 1311,
	"./peony.jpg": 1312,
	"./retro.jpg": 1313,
	"./rosie.jpg": 1314,
	"./selfie.jpg": 1315,
	"./solar.jpg": 1316,
	"./street.jpg": 1317,
	"./summer.jpg": 1318,
	"./theBlues.jpg": 1319,
	"./whimsical.jpg": 1320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1300;